import { reskinStyles } from 'core/components/theme/theme-variant';
import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  styledText: {
    display: 'block',
    lineHeight: 1.3
  },
  button: {
    ...reskinStyles(theme, {
      '&&': { backgroundColor: theme.colorPalette.green_100, color: theme.colorPalette.white },
      '&&:hover': { backgroundColor: theme.colorPalette.green_90, color: theme.colorPalette.white }
    }),
    backgroundColor: theme.colorPalette.green_100,
    color: theme.colorPalette.white
  }
});

export default makeStyles(styles);
